import { LoadingButton } from "@mui/lab";
import { ButtonProps, Tooltip } from "@mui/material";

import defaultStyles from "./styles";

export interface StyledButtonProps extends Omit<ButtonProps, "color"> {
  tooltipDescription?: string;
  color?: string;
  styles?: any;
  [rest: string]: any;
}

// Component definition
function StyledLargeButton({
  children,
  styles,
  color,
  tooltipDescription,
  ...rest
}: StyledButtonProps) {
  return (
    <Tooltip title={tooltipDescription}>
      <LoadingButton
        sx={[
          color === "secondary"
            ? defaultStyles.largeSecondary
            : rest.variant === "outlined"
              ? defaultStyles.largePrimaryOutlined
              : defaultStyles.largePrimary,
          styles,
        ]}
        loading={Boolean(rest.loading)}
        {...rest}
      >
        {rest.loading ? "" : children}
      </LoadingButton>
    </Tooltip>
  );
}

export default StyledLargeButton;
